import { useEffect, useRef } from 'react';
import { setUser, useAppDispatch, useAppSelector } from '@spartalabs/pdc-core';
import axios from 'axios';
import { mapFleetViews } from 'utils/mapFleetViews';

export const useFleetViews = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.authSlicer.user);
  const userRef = useRef(user);
  userRef.current = user;

  const token = user.token;

  useEffect(() => {
    if (!token) return undefined;

    let cancelled = false;

    const loadViews = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/Frota/Views`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (cancelled) return;

        const groups = mapFleetViews(response.data);
        const currentUser = userRef.current;
        if (JSON.stringify(currentUser.groups) === JSON.stringify(groups))
          return;

        dispatch(
          setUser({
            user: {
              ...currentUser,
              groups,
            },
          }),
        );
      } catch {
        // Keep groups from login when PDV views are unavailable.
      }
    };

    loadViews();

    return () => {
      cancelled = true;
    };
  }, [dispatch, token]);
};
